@if (loaderService.ISLOADING | async) {
  <div class="progress-loader"></div>
}

